<template>
  <div
    class="swiper-area"
    style="width: 100%;"
  >
    <swiper :options="swiperOption" ref="myswiper" v-if="swiperReset">
      <swiper-slide
        v-for="(item, index) in bannerList"
        :key="index"
      >
        <router-link
          :to="item.to"
          tag="div"
        >
          <img
            class="banner-item"
            :src="$store.getters.mobile ? item.mobileImg : item.img"
          />
          <p class="sinfo" v-if="item.info">{{item.info}}</p>
        </router-link>
      </swiper-slide>
      <div
        class="swiper-pagination"
        v-show="pagination"
        slot="pagination"
      ></div>
    </swiper>
    <div
      class="swiper-button-next swiper-next swiper-button"
      v-show="!$store.getters.mobile && bannerList.length > 1"
    ></div>
    <div
      class="swiper-button-prev swiper-prev swiper-button"
      v-show="!$store.getters.mobile && bannerList.length > 1"
    ></div>
    <div class="swiper-search" v-show="$route.path == '/home'">
      <div class="search-title">
        <img
          class="search-img"
          src="../assets/zlxcimgs/home_image-logoquan@2x.png"
        >
        <p class="search-circle"></p>
        <p class="search-text">关爱生命  关注安全</p>
      </div>
      <div class="qrCode">
        <div class="codeImg"> <img src="../assets/zlxcimgs/home_icon_appxiazai@2x.png" alt=""></div>
        <div class="iconImg"> <img src="../assets/zlxcimgs/home_image_banner@2x_03.png" alt=""></div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  props: {
    bannerList: {
      type: Array
    },
    pagination: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      swiperReset: true,
      swiperOption: {
        autoHeight: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 5000
        },
        speed: 500,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
          // bulletActiveClass: 'bullet-active'
        },
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        }
      }
    }
  },
  computed: {
    ...mapState({
      mobile: state => state.user.mobile
    })
  },
  watch: {
    mobile() {
      // 修复轮播图切换图片loop下生成的solid不更新问题
      this.swiperReset = false;
      this.$nextTick(() => {
        this.swiperReset= true
      })
    }
  },
}
</script>

<style lang="scss" scoped>
  .swiper-area{
    width: 100vw;
    min-width: 1400px;
    height: 397px;
    position: relative;
    top: 0;
    left: 0;
    ::v-deep .swiper-container-autoheight, .swiper-container-autoheight .swiper-slide{
      height: 397px;
    }
    .swiper-search{
      width: 40%;
      position: absolute;
      top: 18%;
      left: 14%;
      z-index: 999;
      .search-title{
        display: flex;
        align-items: center;
        width: 100%;
        margin-bottom: 18px;
        .search-img{
          width: 33%;
          margin-right: 33px;
        }
        .search-circle{
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #F0AF12;
          margin-right: 18px;
        }
        .search-text{
          font-size: 24px;
          color: #FEFEFE;
        }
      }
    }
  }
  .qrCode {
    display: flex;
    align-items: center;
    padding-top: 20px;
    .codeImg {
      width: 100px;
      img {
        display: block;
        width: 100%;
      }
    }
    .iconImg {
      width: 100px;
      margin-left: 20px;
      img {
        display: block;
        width: 100%;
      }
    }
  }
</style>